import React from 'react';
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import MeChildHeader from '../../../../components/me-child-header';
import RightToLeft from '../../../../../../components/transitions/right-to-left';
import { IMAGE_GEEKO_LTD } from '../../../../../../../constants';
import { useIntl } from 'react-intl';

const List = props => {
    const {toChangeCurrency, currencyLocale, currencies} = props

    return (
        <div className={classes.ListBox}>
            <div className={classes.List}>
                <ul>
                    {
                        currencies?.map((item, index) => (
                            <li className={`${classes.Item} ${currencyLocale === item.value ? classes.active: ''}`} key={item?.value+index} onClick={() => toChangeCurrency(item?.value)}>
                                <span className={classes.Image} style={{backgroundImage: `url(${IMAGE_GEEKO_LTD}/site/ninimour/flags/flag-${item.value}.png)`}}/>
                                <span >{item?.label}</span>
                            </li>
                        ))
                    }
                </ul>
            </div>
        </div>
    )
}

const CurrencyList = props => {
    useStyles(classes)
    const { show, onClose } = props || {}
    const Intl = useIntl()

    return (
            <RightToLeft in={show} className={classes.CurrenctListPage}>
                <div>
                    <MeChildHeader name={Intl.formatMessage({id: 'currency'})} onBack={() => onClose()}/>
                    <List {...props} />
                </div>
            </RightToLeft>
    )
}

export default CurrencyList